import { buildNupayState, encodeNupayState } from "../api/checkAuthStatus";
import { notifyFailedAuth } from "../api/notifyFailedAuth";

export const notifyFailedEnrollment = (context, _event) =>
  // eslint-disable-next-line no-async-promise-executor
  new Promise(async (resolve, reject) => {
    try {
      await notifyFailedAuth({
        nupayOAuthState: encodeNupayState(buildNupayState()),
      });
      resolve(null);
    } catch (error) {
      reject({
        error,
      });
    }
  });
